import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { typePersianConverter } from "../../../utils/Functions";
import LoadingButton from "../../common/loadingButton";
import Checkbox from "../../form/checkbox";
import UserIcon from "../../../assets/icons/profile.svg";
import TypeIcon from "../../../assets/icons/filter.svg";

const TestFilter = ({
  records,
  onSubmitFilters,
}: {
  records: any;
  onSubmitFilters: (users: string[]) => void;
}) => {
  const [uniqueNames, setUniqueNames] = useState<string[]>([]);

  const [checkedItems, setCheckedItems] = useState<{
    users: string[];
  }>({
    users: [],
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const users = params.get("users") ? params.get("users")!.split(",") : [];

    setCheckedItems({ users });
  }, []);

  useEffect(() => {
    const namesSet = new Set<string>();

    records.forEach((entry: any) => {
      if (entry.creator?.first_name || entry.temp_user?.first_name) {
        namesSet.add(
          entry.is_for_other
            ? `${entry.temp_user?.first_name} ${entry.temp_user?.last_name}`
            : `${entry.creator?.first_name} ${entry.creator?.last_name}`
        );
      }
    });

    //@ts-ignore
    setUniqueNames([...namesSet]);
  }, [records]);

  const { handleSubmit } = useForm();

  const onSubmit = () => {
    onSubmitFilters(checkedItems.users);
  };

  const handleCheckboxChange = (id: string, type: "type" | "user") => {
    setCheckedItems((prev) => {
      //@ts-ignore
      const currentItems = prev[type] || [];
      return {
        ...prev,
        [type]: currentItems.includes(id)
          ? currentItems.filter((item: any) => item !== id)
          : [...currentItems, id],
      };
    });
  };

  return (
    <form
      method="dialog"
      onSubmit={handleSubmit(onSubmit)}
      className="flex-1 w-full max-w-lg flex flex-col justify-between min-h-[423px]"
    >
      <div className="flex-1">
        {uniqueNames.length > 0 && (
          <div>
            <div className="flex items-center mt-10 mb-3">
              <img
                src={UserIcon}
                width={20}
                className="ml-2"
                alt="آزمایش‌دهنده"
              />
              <h2 className="mt-1 font-[700] font-rokh">آزمایش‌دهنده</h2>
            </div>

            {uniqueNames.map((name) => (
              <Checkbox
                key={name}
                id={name.replace(/ /g, "_")}
                label={name}
                checkedItems={checkedItems.users}
                //@ts-ignore
                onChange={(id) => handleCheckboxChange(id, "users")}
                isFullWidth
                isSmall
              />
            ))}
          </div>
        )}
      </div>
      <LoadingButton title="فیلتر" type="submit" disabled={false} />
    </form>
  );
};

export default TestFilter;
